import React, { useState, useEffect } from 'react';
import Globals from '../Globals';

const API = Globals.API;

function Contact() {
 const [showSuccess, setShowSuccess] = useState(false);
 const [formData, setFormData] = useState({
 name: '', email: '', phone: '', subject: '', message: ''
 });
 const [error, setError] = useState('');

 const handleChange = (e) => {
 setFormData({ ...formData, [e.target.name]: e.target.value });
 };

 const handleSubmit = async (e) => {
 e.preventDefault();
 setError('');
 try {
 const response = await fetch(`${API}/reservations/contact`, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify(formData)
 });
 if (!response.ok) throw new Error('Failed to send message.');
 setShowSuccess(true);
 setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
 setTimeout(() => setShowSuccess(false), 5000);
 } catch (err) {
 setError(err.message || 'Something went wrong.');
 }
 };

 useEffect(() => {
 const urlParams = new URLSearchParams(window.location.search);
 if (urlParams.get('success') === 'true') {
 setShowSuccess(true);
 setTimeout(() => {
 window.history.replaceState({}, '', window.location.pathname);
 setShowSuccess(false);
 }, 5000);
 }
 }, []);

 return (
 <div>

 {/* ══ HERO ══ */}
 <div className="container-fluid bg-white py-5 mb-0 hero-header">
 <div className="container">

   <div className="row justify-content-center">
 <div className="col-lg-10 text-center">
 <h1 className="display-3 text-white animated slideInDown">Contactez-nous</h1>
 </div>
 </div>
 </div>
 </div>

 {/* ══ FORMULAIRE ══ */}
 <div className="container py-5">

 {/* Box formulaire */}
 <div className="row justify-content-center mb-5">
 <div className="col-lg-10">
 <div style={{
 border: '1px solid #e0e6f0',
 borderRadius: '16px',
 padding: '3.5rem 2.5rem',
 background: '#fff',
 boxShadow: '0 2px 16px rgba(43,76,126,0.07)'
 }}>
 <div className="row g-4 align-items-start">

 {/* Texte gauche */}
 <div className="col-lg-6">
 <h4 className="fw-bold mb-2" style={{ color: '#00338C' , fontSize : '2.5rem' , fontFamily: 'Inter, sans-serif' }}>Entrer en contact</h4>
 <p className='py-4' style={{ color: '#01225C', lineHeight: '1.7' ,fontFamily: 'Inter, sans-serif',}}>
 Votre voyage commence par un simple message !
 </p>
 <p style={{ color: '#01225C', lineHeight: '1.7' , fontSize: '1.25rem' ,fontFamily: 'Inter, sans-serif',}}>
 <strong>Contactez-nous pour une planification de voyage sans faille avec Aviator.</strong>
 </p>
 </div>

 {/* Formulaire droite */}
 <div className="col-lg-6">
 {showSuccess && (
 <div className="alert alert-success alert-dismissible fade show" role="alert">
 <i className="fa fa-check-circle me-2"></i>
 <strong>Message envoyé avec succès !</strong> Nous vous contacterons bientôt.
 <button type="button" className="btn-close" onClick={() => setShowSuccess(false)}></button>
 </div>
 )}
 {error && (
 <div className="alert alert-danger alert-dismissible fade show" role="alert">
 {error}
 <button type="button" className="btn-close" onClick={() => setError('')}></button>
 </div>
 )}

 <form onSubmit={handleSubmit}>
 <div className="row g-3">
 {/* Nom + Email */}
 <div className="col-md-6">
 <input
 type="text"
 className="form-control"
 name="name"
 placeholder="Votre nom"
 value={formData.name}
 onChange={handleChange}
 required
 style={{ borderRadius: '8px', padding: '0.65rem 1rem', border: '1px solid #CBDEFC' , background: '#FBFDFF' ,color: '#00338C' }}
 />
 </div>
 <div className="col-md-6">
 <input
 type="email"
 className="form-control"
 name="email"
 placeholder="Votre email"
 value={formData.email}
 onChange={handleChange}
 required
 style={{ borderRadius: '8px', padding: '0.65rem 1rem',border: '1px solid #CBDEFC' , background: '#FBFDFF' ,color: '#00338C' }}
 />
 </div>

 {/* Téléphone */}
 <div className="col-12">
 <input
 type="text"
 className="form-control"
 name="phone"
 placeholder="Téléphone"
 value={formData.phone}
 onChange={handleChange}
 required
 style={{ borderRadius: '8px', padding: '0.65rem 1rem',border: '1px solid #CBDEFC' , background: '#FBFDFF' ,color: '#00338C' }}
 />
 </div>

 {/* Sujet */}
 <div className="col-12">
 <input
 type="text"
 className="form-control"
 name="subject"
 placeholder="Sujet"
 value={formData.subject}
 onChange={handleChange}
 required
 style={{ borderRadius: '8px', padding: '0.65rem 1rem',border: '1px solid #CBDEFC' , background: '#FBFDFF' ,color: '#00338C' }}
 />
 </div>

 {/* Message */}
 <div className="col-12">
 <textarea
 className="form-control"
 name="message"
 placeholder="Message"
 rows={4}
 value={formData.message}
 onChange={handleChange}
 required
 style={{ borderRadius: '8px', padding: '0.65rem 1rem',border: '1px solid #CBDEFC' , background: '#FBFDFF' ,color: '#00338C' }}
 />
 </div>

 {/* Bouton aligné à droite */}
 <div className="col-12 d-flex justify-content-center">
 <button
 type="submit"
 style={{
 background: '#00338C',
 color: '#fff',
 border: 'none',
 borderRadius: '8px',
 padding: '0.7rem 2rem',
 fontWeight: '600',
 fontSize: '0.95rem',
 cursor: 'pointer',
 transition: 'opacity 0.2s'
 }}
 onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
 onMouseLeave={e => e.currentTarget.style.opacity = '1'}
 >
 Envoyer le message
 </button>
 </div>
 </div>
 </form>
 </div>

 </div>
 </div>
 </div>
 </div>

 {/* ══ INFOS CONTACT — 3 colonnes ══ */}
 <div className="row justify-content-center mb-4 g-3">
 <div className="col-lg-10">
 <div className="row g-3">

 {/* Bureau */}
 <div className="col-md-4">
 <div className="d-flex align-items-start gap-3">
 <div style={{
 width: '42px', minWidth: '42px', height: '42px',
 background: '#00338C', 
 display: 'flex', alignItems: 'center', justifyContent: 'center'
 }}>
 <i className="fa fa-map-marker-alt text-white"></i>
 </div>
 <div>
 <h6 className="fw-bold mb-1" style={{ color: '#00338C' , fontFamily : 'Inter, sans-serif' }}>Bureau</h6>
 <p className="mb-0 text-muted" style={{ fontSize: '0.88rem', lineHeight: '1.6' }}>
 Agence Ennasr: 32, Avenue Hédi Nouira - Résidence Abou Kacem Chebbi Bureau A2- Ennasr 2, Ariana Tunis, Ariana, Tunisie
 </p>
 </div>
 </div>
 </div>

 {/* Mobile */}
 <div className="col-md-4">
 <div className="d-flex align-items-start gap-3">
 <div style={{
 width: '42px', minWidth: '42px', height: '42px',
 background: '#00338C', 
 display: 'flex', alignItems: 'center', justifyContent: 'center'
 }}>
 <i className="fa fa-phone-alt text-white"></i>
 </div>
 <div>
 <h6 className="fw-bold mb-1" style={{ color: '#00338C' , fontFamily : 'Inter, sans-serif'}}>Mobile</h6>
 <p className="mb-0 text-muted" style={{ fontSize: '0.88rem' , color: '#545B61' }}>+216 29 308 000</p>
 </div>
 </div>
 </div>

 {/* Email */}
 <div className="col-md-4">
 <div className="d-flex align-items-start gap-3">
 <div style={{
 width: '42px', minWidth: '42px', height: '42px',
 background: '#00338C', 
 display: 'flex', alignItems: 'center', justifyContent: 'center'
 }}>
 <i className="fa fa-envelope-open text-white"></i>
 </div>
 <div>
 <h6 className="fw-bold mb-1" style={{ color: '#00338C' , fontFamily : 'Inter, sans-serif' }}>Email</h6>
 <p className="mb-0 text-muted" style={{ fontSize: '0.88rem' , color: '#545B61' }}>booking@aviatortravel.tn</p>
 </div>
 </div>
 </div>

 </div>
 </div>
 </div>

 {/* ══ CARTE GOOGLE MAPS — pleine largeur ══ */}
 <div className="row justify-content-center">
 <div className="col-lg-10">
 <iframe
 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3192.4159744160165!2d10.15774237530569!3d36.85646086452697!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd3351fc0f5b7b%3A0xbd35f096c69e90e0!2sAlways%20Travel%20Services!5e0!3m2!1sfr!2stn!4v1763108536622!5m2!1sfr!2stn"
 width="100%"
 height="350"
 style={{ border: 0, borderRadius: '16px', display: 'block' }}
 allowFullScreen=""
 aria-hidden="false"
 tabIndex={0}
 title="Carte Aviator Travel"
 />
 </div>
 </div>

 </div>

 </div>
 );
}

export default Contact;